import { AccountStorage } from '~/storages/account';
import { getSubdomain } from '~/helpers/getSubdomain';

/**
 * FilterStorage — keeps a page's filters in localStorage for a few minutes so
 * they survive a refresh. Each entry is namespaced by tenant + user + page, so
 * pages (and accounts sharing a browser) never read each other's filters.
 *
 * Values must be JSON-serializable: store dates as strings ('YYYY-MM-DD' or
 * 'YYYY-MM'), never moment objects.
 */

var PREFIX = 'contlabs:filters';
var VERSION = 1;
export var DEFAULT_FILTER_TTL_MINUTES = 30;

var getStorage = function() {
  try {
    return window.localStorage;
  } catch (e) {
    return null;
  }
};

var getScope = function() {
  var tenant = null;
  var userId = null;
  try {
    tenant = getSubdomain() || null;
    var account = AccountStorage.get();
    userId = account.user && account.user.id;
  } catch (e) {}
  return (tenant || 'anon') + ':' + (userId || 'anon');
};

export var buildFilterKey = function(pageKey, scope) {
  return PREFIX + ':' + (scope || getScope()) + ':' + pageKey;
};

export var FilterStorage = {
  read: function(pageKey, options) {
    var opts = options || {};
    var ttlMinutes = opts.ttlMinutes || DEFAULT_FILTER_TTL_MINUTES;
    var now = opts.now || Date.now();
    var storage = getStorage();
    if (!storage) return null;

    var key = buildFilterKey(pageKey, opts.scope);
    try {
      var raw = storage.getItem(key);
      if (!raw) return null;
      var entry = JSON.parse(raw);
      if (!entry || entry.v !== VERSION || !entry.savedAt || !entry.data) {
        storage.removeItem(key);
        return null;
      }
      if (now - entry.savedAt > ttlMinutes * 60 * 1000) {
        storage.removeItem(key);
        return null;
      }
      return entry.data;
    } catch (e) {
      try { storage.removeItem(key); } catch (err) {}
      return null;
    }
  },

  save: function(pageKey, data, options) {
    var opts = options || {};
    var storage = getStorage();
    if (!storage) return;
    try {
      storage.setItem(
        buildFilterKey(pageKey, opts.scope),
        JSON.stringify({ v: VERSION, savedAt: opts.now || Date.now(), data: data })
      );
    } catch (e) {}
  },

  remove: function(pageKey, options) {
    var opts = options || {};
    var storage = getStorage();
    if (!storage) return;
    try {
      storage.removeItem(buildFilterKey(pageKey, opts.scope));
    } catch (e) {}
  },

  // Removes every saved filter (all pages, all accounts). Used on logout.
  clearAll: function() {
    var storage = getStorage();
    if (!storage) return;
    try {
      var keys = [];
      for (var i = 0; i < storage.length; i++) {
        var key = storage.key(i);
        if (key && key.indexOf(PREFIX + ':') === 0) keys.push(key);
      }
      keys.forEach(function(key) { storage.removeItem(key); });
    } catch (e) {}
  },
};
